import { createFileRoute, redirect } from "@tanstack/react-router";

import { parseTemplatesSearch } from "../../../../areas/seller/more/templates/search";

/** FE-09 names the gallery `/app/more/templates`; FE-01 §6.1 owns the path `/app/more/gallery`. */
export const Route = createFileRoute("/app/_seller/more/templates")({
  validateSearch: parseTemplatesSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/app/more/gallery", search, replace: true });
  },
});
